export default "__VITE_ASSET__Dj$DjZo___"